<app-page-header icon="menu" title="Menúes" subtitle="Alta, baja y modificación de menúes del sistema"></app-page-header>

<app-spinner
    [show]="!flagLoaded"
    [type]="'fullscreen'"
    [size]="'large'"
    [color]="'#B1476A'"
    [trackColor]="'#4CA7C8'"
    [text]="'Cargando menúes...'"
    [showText]="true"
    [blurBackground]="true">
</app-spinner>

<div *ngIf="!flagLoaded" style="height: 100vh;"></div>

<div *ngIf="flagLoaded" class="seguridad-area seguridad-animate-in">
  <div class="container">
    <div class="barra-superior">
      <button mat-stroked-button class="btn-volver" (click)="volver()">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
      <button mat-stroked-button class="btn-crear" (click)="crearNuevo()">
        <mat-icon>add</mat-icon> Crear nuevo menú
      </button>
    </div>

    <div class="toolbar">
      <mat-form-field class="buscador" appearance="outline">
        <mat-label>Buscar menú</mat-label>
        <span class="material-icons" matPrefix>search</span>
        <input
          matInput
          [ngModel]="termino"
          (ngModelChange)="aplicarFiltro($event)"
          placeholder="Nombre, ruta..."
          autocomplete="off"
        />
      </mat-form-field>

      <button mat-stroked-button class="btn-toggle" (click)="toggleExpandAll()">
        <mat-icon>{{ allExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
        {{ allExpanded ? 'Colapsar todo' : 'Expandir todo' }}
      </button>
    </div>

    <div class="menu-tree-wrapper">
      <div class="tree-header">
        <span class="tree-header__name">Nombre</span>
        <span class="tree-header__route">Ruta</span>
        <span class="tree-header__tipo">Tipo</span>
        <span class="tree-header__level">Nivel</span>
        <span class="tree-header__order">Orden</span>
        <span class="tree-header__acciones">Acciones</span>
      </div>

      <ng-template #arbolNodo let-nodes="nodes" let-indent="indent">
        <div *ngFor="let node of nodes" class="tree-node-group" [class.tree-node-group--hidden]="!node.visible">
          <div class="tree-row" [style.paddingLeft.px]="indent">
            <button *ngIf="node.children.length; else spacer" mat-icon-button class="tree-toggle-btn"
                    (click)="toggleExpand(node); $event.stopPropagation()">
              <mat-icon class="tree-toggle-icon">
                {{ node.expanded ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            </button>
            <ng-template #spacer>
              <span class="tree-leaf-indent"></span>
            </ng-template>

            <span class="tree-name">{{ node.name }}</span>
            <code class="tree-route">{{ node.redirectTo }}</code>
            <span class="chip">{{ node.tipo }}</span>
            <span class="tree-level">L{{ node.level }}</span>

            <span class="tree-order">
              {{ node.order }}
              <button mat-icon-button class="tree-order-btn" (click)="cambiarOrden(node, -1); $event.stopPropagation()" title="Subir orden">
                <mat-icon>keyboard_arrow_up</mat-icon>
              </button>
              <button mat-icon-button class="tree-order-btn" (click)="cambiarOrden(node, 1); $event.stopPropagation()" title="Bajar orden">
                <mat-icon>keyboard_arrow_down</mat-icon>
              </button>
            </span>

            <span class="tree-acciones">
              <button mat-icon-button color="primary" title="Editar" (click)="editarMenu(node)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" title="Eliminar" (click)="confirmarEliminar(node)">
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </div>

          <ng-container *ngIf="node.expanded && node.children.length">
            <ng-container *ngTemplateOutlet="arbolNodo; context: { nodes: node.children, indent: indent + 28 }">
            </ng-container>
          </ng-container>
        </div>
      </ng-template>

      <ng-container *ngTemplateOutlet="arbolNodo; context: { nodes: treeRoots, indent: 16 }">
      </ng-container>
    </div>
  </div>
</div>
